import React, { useEffect, useState, useMemo, useCallback } from "react";
import { useDispatch, useSelector } from "react-redux";
import { api_url } from "../../../../../../constants";
import FormGenerator from "../../../../../../Components/FormGenerator";
import {
  SetWorkInformation,
  UpdateWorkInformationError,
} from "./WorkInformationActions";
import { useParams, useLocation } from "react-router-dom";
import DataService from "../../../../../../Service";
import { Grid } from "@material-ui/core";
import { ErrorSharp } from "@material-ui/icons";

// const theme = createMuiTheme({
//   overrides: {
//     MuiFormControl: {
//       root: {
//         width: "100%",
//       },
//     },
//   },
// });

export default function Profile(props) {
  const dispatch = useDispatch();
  const [feildIsMandatory, setFeildIsMandatory] = useState(true);

  const [countyList, setCountyList] = useState([]);
  const [cityList, setCityList] = useState([]);
  const [magicFieldData, setMagicFieldData] = useState();
  const hideField = [
    "Person status (Retired, Left, Current, etc)*",
    "Current Role History Notes",
    "Past Organization",
    "Left Organization Follow up Action",
    "Date Follow Up Contact Made",
    "Organization Moved to",
  ];

  const {
    job_title,
    employee_status_id,
    current_role_history_notes,
    date_follow_up_contact_made,
    organisation_moved_to,
    level,
    pa_name,
    pa_contact_details,
    line_manager_title,
    line_manager_name,
    line_manager_contact_details,
    lm_pa_name,
    franchises,
    lm_pa_contact_details,
    lob_leader_name,
    hr_sponsor_title,
    hr_sponsor_name,
    hr_sponsor_contact_details,
    group,
    department_list_id,
    office_list_id,
    function_list_id,
    address_line1,
    address_line2,
    city,
    county,
    country_list_id,
    phone,
    selected_job_roles,
    postcode,
    address,
    left_organisation_follow_up_action,
    past_organisation,
    job_role_lists,
    magic20_fields,
  } = useSelector((state) => state.workInformationReducer.data);
  const fieldsData = useSelector((state) => state.workInformationReducer.data);

  const jobRoleListsSelector = useSelector(
    (state) => state.commonReducer.employeeDropdowns.job_role_lists
  );

  const { organisations, internal_job_titles, access_levels } = useSelector(
    (state) => state.commonReducer.employeeDropdowns
  );

  const globaluserData = useSelector((state) => state.commonReducer);
  const userRole = globaluserData?.role;

  const handleCountyList = (value) => {
    DataService.getData({ country: value }, "listing_county").then((res) => {
      const county_list = res.states.map((item, index) => ({
        value: item,
        id: item,
      }));
      setCountyList(county_list);
    });
  };
  const handleCityList = (country, county) => {
    DataService.getData(
      { country: country, state: county },
      "listing_cities"
    ).then((res) => {
      const city_list = res.cities.map((item, index) => ({
        value: item,
        id: item,
      }));
      setCityList(city_list);
    });
  };

  useEffect(() => {
    if (userRole === "employee") {
      setFeildIsMandatory(false);
    }
  }, []);

  const {
    employee_statuses,
    level_structure_values,
    department_lists,
    office_lists,
    function_lists,
    org_level_structure,
    country_lists,
  } = useSelector((state) => state.commonReducer.employeeDropdowns);
  const errors = useSelector((state) => state.workInformationReducer.errors);

  let { id } = useParams();
  const franchiseSelector = useSelector(
    (state) => state.commonReducer.employeeDropdowns.franchises
  );
  //
  useEffect(() => {
    DataService.getDirectData(`/organisations/${id}`).then((response) => {
      setOrgID(response.organisation_contact_info_id);
      response &&
        response.organisation_contact_info_id &&
        DataService.getDirectData(
          `/organisation_contact_infos/${response.organisation_contact_info_id}`
        ).then((res) => {
          setMagicFieldData(res.data.magic20_fields);
        });
    });
  }, [id]);

  //

  const handleInputChange = useCallback(
    (value, index, type, isDynamicField) => {
      props.setSomeChangeDetected(true);
      //=====================================================
      // This logic is for updating the dynamic field's value
      if (typeof isDynamicField === "boolean" && isDynamicField) {
        let keyIndex = formInput.findIndex(
          (item) => item.componentType === "DynamicFields"
        );
        setFormInput((prev) => {
          const newlyUpdatedForm = [...prev];
          if (newlyUpdatedForm[keyIndex].fields.length > index) {
            newlyUpdatedForm[keyIndex].fields[index].value = value ?? "";
          }
          const formData = {};
          newlyUpdatedForm.forEach((item, fIndex) => {
            formData[item.name] = item.value ?? "";
            if (fIndex === keyIndex) {
              formData[item.name] = item.value ?? "";
              dispatch(SetWorkInformation(formData));
            }
          });
          return newlyUpdatedForm;
        });
      } else if (
        typeof isDynamicField === "string" &&
        isDynamicField === "magic20_fields"
      ) {
        setFormInput((prev) => {
          const newlyUpdatedForm = [...prev];
          if (
            newlyUpdatedForm[
              newlyUpdatedForm.findIndex((el) => el.name === "magic20_fields")
            ]
          ) {
            newlyUpdatedForm[
              newlyUpdatedForm.findIndex((el) => el.name === "magic20_fields")
            ].value = value;
          }
          dispatch(SetWorkInformation(newlyUpdatedForm));
          return newlyUpdatedForm;
        });
      }
      // //=====================================================
      else if (!type) {
        setFormInput((prev) => {
          const newlyUpdatedForm = [...prev];
          newlyUpdatedForm[index]["value"] = value;
          return newlyUpdatedForm;
        });
      } else {
        setFormInput((prev) => {
          const newlyUpdatedForm = [...prev];
          newlyUpdatedForm[index][type] = value;
          return newlyUpdatedForm;
        });
      }
      setFormInput((prev) => {
        const formData = {};
        const newlyUpdatedForm = [...prev];
        newlyUpdatedForm.forEach((item) => {
          formData[item.name] = item.value;
          formData[item.inputName] = item.inputValue;
          formData[item.selectName] = item.selectValue;
          // dispatch(SetWorkInformation(formData));
        });
        // for dynamic genrated fields

        let modifiedData = [];
        newlyUpdatedForm[1].value?.forEach((role) => {
          newlyUpdatedForm[1]["fields"].forEach((item) => {
            if (item.for.includes(role?.toLowerCase())) {
              modifiedData.push({ job_role: role, access_level: item.value });
            }
          });
        });
        formData["job_role_lists"] = modifiedData;
        dispatch(SetWorkInformation(formData));
        dispatch(UpdateWorkInformationError(newlyUpdatedForm[index].name));
        return newlyUpdatedForm;
      });
    },
    [magicFieldData]
  );
  const isEmployee = userRole === "employee";
  const [lastFields, setLastFields] = useState([
    {
      error: false,
      // helperText:isEmployee?(countryError ?"Please select the fields":""):false,
      componentType: "inputWithDropdown",
      label: "",
      grid: "yes",
      type: "text",
      inputName: "postcode",
      selectName: "country_list_id",
      inputPlaceholder: isEmployee
        ? "Office post/zip code *"
        : "Office post/zip code",
      selectPlaceholder: isEmployee
        ? "* Select office country"
        : "Select office country",
      selectOptions: country_lists,
      handleInputChange: handleInputChange,
      handleSelectChange: handleInputChange,
      inputValue: postcode,
      selectValue: country_list_id,
      selectWithAutoComplete: true,
      totalError: {
        inputError: false,
        selectError: false,
        inputErrorMsg: "",
        selectErrorMsg: "",
      },
    },
    {
      componentType: "phone",
      label: isEmployee ? "Office phone*" : "Office phone",
      error: isEmployee && (phone?.length < 4 || errors.phone),
      errorMsg: undefined,
      name: "phone",
      placeholder: "Office phone",
      handleChange: handleInputChange,
      value: phone,
    },
  ]);
  console.log(errors, "errors inside");

  // Form disabling
  const location = useLocation();

  let organisation_id = globaluserData?.organisation_id;
  let employee_id = globaluserData?.employee_id;
  const params = useParams();
  let unEditable = false;
  const isSameEmployee =
    userRole === "employee" &&
    Number(params.id) === Number(organisation_id) &&
    Number(employee_id) === Number(params.employeeid);
  if (location?.state?.unEditable && !isSameEmployee) {
    unEditable = true;
  }
  const formDisabler = (el) => {
    if (unEditable) {
      return { ...el, disabled: true };
    } else {
      return el;
    }
  };

  const formArray = [
    {
      componentType: "input",
      label: isEmployee ? "Job title* " : "Job title",
      helperText: isEmployee
        ? errors.job_title
          ? "Please enter a job role"
          : ""
        : false,
      name: "job_title",
      errors: isEmployee && errors.job_title,
      placeholder: "Job title",
      handleChange: handleInputChange,
      // Sakthi - please integrate the correct select options here, this is a dummy one
      // selectOptions: internal_job_titles,
      value: job_title,
    },

    {
      componentType: "DynamicFields",
      fieldTyp: "MultipleSelect",
      label: "Internal job role (any role they have with us, e.g. coachee)*",
      name: "selected_job_roles",
      value: job_role_lists?.map((item) => item.job_role),
      placeholder: "Select job role",
      fields: [],
      selectOptions: jobRoleListsSelector,
      handleChange: handleInputChange,
      helperText:
        errors && errors.selected_job_roles && "Please select the Job Role",
      dropDown: "JobRoleList",
      field_name: "job_role",
    },
    {
      componentType: "select",
      label: "Person status (Retired, Left, Current, etc)*",
      helperText:
        errors && errors.employee_status_id && "Please select employee status",
      name: "employee_status_id",
      value: employee_status_id,
      placeholder: "Select person status",
      selectOptions: employee_statuses,
      // selectOptions: [
      //   { id: 0, value: "Current", name: "Current" },
      //   { id: 1, value: "Left", name: "Left" },
      //   { id: 1, value: "Other", name: "Other" },
      //   { id: 1, value: "Retired", name: "Retired" },
      // ],
      handleChange: handleInputChange,
      dropDown: "EmployeeStatus",
      field_name: "status",
    },
    {
      componentType: "input",
      type: "text",
      label: "Current role history notes",
      helperText:
        errors.current_role_history_notes &&
        "Please enter a Current Role History Notes",
      name: "current_role_history_notes",
      placeholder: "Current role history notes",
      multiline: true,
      handleChange: handleInputChange,
      value: current_role_history_notes,
      dropDown: "EmployeeStatus",
      field_name: "status",
    },

    {
      componentType: "multiSelectChip",
      // label:feildIsMandatory === false ? "Past Organization" :"Past Organization*",
      label: "Past organization",
      name: "past_organisation",
      value: past_organisation,
      placeholder: "Select past organization",
      itemArr: organisations,
      selectOptions: organisations,
      // apiVariable: "organisation_list",
      handleChange: handleInputChange,
      dropDown: "PastOrganisation",
      field_name: "organisation_name",
      helperText:
        errors && errors.past_organisation && "Please select Past Organization",
    },
    {
      componentType: "input",
      type: "text",
      label: "Left organization follow up action",
      name: "left_organisation_follow_up_action",
      placeholder: "Left organization follow up action",
      handleChange: handleInputChange,
      value: left_organisation_follow_up_action,
      multiline: true,
      helperText:
        errors &&
        errors.left_organisation_follow_up_action &&
        "Please enter Left Organization Follow up Action",
    },
    {
      componentType: "datePicker",
      required: true,
      label: "Date follow up contact made",
      name: "date_follow_up_contact_made",
      value: date_follow_up_contact_made,
      handleChange: handleInputChange,
      helperText: errors.date_follow_up_contact_made && "Please enter a Date",
    },
    {
      componentType: "input",
      type: "text",
      label: "Organization moved to",
      helperText:
        errors.organisation_moved_to && "Please enter a Organization Moved to",
      name: "organisation_moved_to",
      placeholder: "Organization moved to",
      handleChange: handleInputChange,
      value: organisation_moved_to,
    },
    {
      componentType: "select",
      type: "text",
      label: `${org_level_structure ? org_level_structure : "Level/Grade"} ${
        isEmployee ? "*" : ""
      }`,
      helperText: isEmployee
        ? errors.level &&
          `Please enter a ${
            org_level_structure ? org_level_structure : "Level/Grade"
          }`
        : false,
      errors: isEmployee && errors.level,
      name: "level",
      placeholder: `${
        org_level_structure ? org_level_structure : "Level/Grade"
      }`,
      selectOptions: level_structure_values,
      // apiVariable: "level_dropdown_values",
      params: { organisation_id: id },
      handleChange: handleInputChange,
      value: level,
    },
    {
      componentType: "input",
      type: "text",
      label: "PA name",
      helperText: errors.pa_name && "Please enter the PA Name",
      name: "pa_name",
      placeholder: "PA name",
      handleChange: handleInputChange,
      value: pa_name,
    },
    {
      componentType: "input",
      type: "text",
      label: "PA contact details",
      helperText:
        errors.pa_contact_details && "Please enter a PA Contact Details",
      name: "pa_contact_details",
      placeholder: "PA contact details",
      handleChange: handleInputChange,
      value: pa_contact_details,
    },
    {
      componentType: "input",
      type: "text",
      label: isEmployee ? "Line manager name*" : "Line manager name",
      helperText: isEmployee
        ? errors.line_manager_name && "Please enter the Line Manager Name"
        : false,
      errors: isEmployee && errors.line_manager_name,
      name: "line_manager_name",
      placeholder: "Line manager name",
      handleChange: handleInputChange,
      value: line_manager_name,
    },
    {
      componentType: "input",
      type: "text",
      label: "Line manager title",
      name: "line_manager_title",
      placeholder: "Line manager title",
      handleChange: handleInputChange,
      value: line_manager_title,
    },
    {
      componentType: "input",
      type: "text",
      helperText: isEmployee
        ? errors.line_manager_contact_details &&
          "Please enter the Line Manager Contact Details"
        : false,
      errors: isEmployee && errors.line_manager_contact_details,
      label: isEmployee
        ? "Line manager contact details*"
        : "Line manager contact details",
      name: "line_manager_contact_details",
      placeholder: "Line manager contact details",
      handleChange: handleInputChange,
      value: line_manager_contact_details,
    },
    {
      componentType: "input",
      type: "text",
      label: "Line manager PA name",
      helperText: errors.lm_pa_name && "Please enter the Line Manager PA Name",
      name: "lm_pa_name",
      placeholder: "Line manager PA name",
      handleChange: handleInputChange,
      value: lm_pa_name,
    },
    {
      componentType: "input",
      type: "text",
      label: "Line manager PA contact details",
      helperText:
        errors.lm_pa_contact_details &&
        "Please enter the Line Manager PA Contact Details",
      name: "lm_pa_contact_details",
      placeholder: "Line manager PA contact details",
      handleChange: handleInputChange,
      value: lm_pa_contact_details,
    },
    {
      componentType: "input",
      type: "text",
      label: "LOB leader name",
      helperText: errors.lob_leader_name && "Please enter the LOB Leader Name",
      name: "lob_leader_name",
      placeholder: "LOB leader name",
      handleChange: handleInputChange,
      value: lob_leader_name,
    },
    {
      componentType: "input",
      type: "text",
      label: isEmployee ? "HR sponsor name*" : "HR sponsor name",
      helperText: isEmployee
        ? errors.hr_sponsor_name && "Please enter the HR Sponsor Name"
        : false,
      errors: isEmployee && errors.hr_sponsor_name,
      name: "hr_sponsor_name",
      placeholder: "HR sponsor name",
      handleChange: handleInputChange,
      value: hr_sponsor_name,
    },
    {
      componentType: "input",
      type: "text",
      label: isEmployee ? "HR sponsor title*" : "HR sponsor title",
      errors: isEmployee && errors.hr_sponsor_title,
      helperText: isEmployee
        ? errors.hr_sponsor_title && "Please enter the HR Sponsor Title"
        : false,
      name: "hr_sponsor_title",
      placeholder: "HR sponsor title",
      handleChange: handleInputChange,
      value: hr_sponsor_title,
    },
    {
      componentType: "input",
      type: "text",
      label: isEmployee
        ? "HR sponsor contact details*"
        : "HR sponsor contact details",
      helperText: isEmployee
        ? errors.hr_sponsor_contact_details &&
          "Please enter the HR Sponsor Contact Details"
        : false,
      errors: isEmployee && errors.hr_sponsor_contact_details,
      name: "hr_sponsor_contact_details",
      placeholder: "HR sponsor contact details",
      handleChange: handleInputChange,
      value: hr_sponsor_contact_details,
    },
    // {
    //   componentType: "input",
    //   type: "text",
    //   label: "Office street",
    //   // helperText: errors.address_line1 && "Please enter the Office Street",
    //   name: "address_line1",
    //   placeholder: "Office street",
    //   handleChange: handleInputChange,
    //   value: address_line1,
    // },
    // {
    //   componentType: "input",
    //   type: "text",
    //   label: "Office town/city",
    //   helperText: errors.address_line2 && "Please enter the Office town/city",
    //   name: "address_line2",
    //   placeholder: "Office city",
    //   handleChange: handleInputChange,
    //   value: address_line2,
    // },
    // // {
    // //   componentType: "input",
    // //   type: "text",
    // //   label: "City*",
    // //   helperText: errors.city && "Please enter the City",
    // //   name: "city",
    // //   placeholder: "City",
    // //   handleChange: handleInputChange,
    // //   value: city
    // // },
    // {
    //   componentType: "input",
    //   label: feildIsMandatory ? "Office county" : "Office county",
    //   name: "county",
    //   value: county,
    //   placeholder: "Enter office county",
    //   // selectOptions: [
    //   //   { id: 1, value: "Manchester", name: "Manchester" },
    //   //   { id: 2, value: "London", name: "London" },
    //   // ],
    //   selectOptions: countyList,
    //   handleChange: handleInputChange,
    // },
    // {
    //   componentType: "SelectSpecific",
    //   label: feildIsMandatory ? "Office country" : "Office country*",
    //   name: "country_list_id",
    //   id: "country_list_id",
    //   value: country_list_id,
    //   placeholder: "Select office country",
    //   // apiVariable: "countries",
    //   selectOptions: country_lists,
    //   handleChange: handleInputChange,
    //   helperText:
    //     errors && errors.country_list_id && "Please select the Office Country",
    // },

    // {
    //   componentType: "input",
    //   type: "text",
    //   label: feildIsMandatory ? "Office post code" : "Office post code*",
    //   helperText: errors.postcode && "Please enter the Office Post Code",
    //   name: "postcode",
    //   placeholder: "Office post code",
    //   handleChange: handleInputChange,
    //   value: postcode,
    // },
    // {
    //   componentType: "input",
    //   type: "text",
    //   label: feildIsMandatory ? "Office zip code" : "Office zip code*",
    //   helperText: errors.zipcode && "Please enter the Office Zip Code",
    //   name: "zipcode",
    //   placeholder: "Office zip code",
    //   handleChange: handleInputChange,
    //   value: zipcode,
    // },
    {
      componentType: "input",
      type: "text",
      label: isEmployee ? "Office address*" : "Office address",
      errors: isEmployee && errors.address,
      helperText: isEmployee
        ? errors.address
          ? "Please enter office address"
          : ""
        : false,
      name: "address",
      value: address,
      placeholder: "Office address",
      handleChange: handleInputChange,
    },
    {
      componentType: "input",
      type: "text",
      // label: "Office Street",
      name: "address_line1",
      value: address_line1,
      placeholder: "Office address line1",
      handleChange: handleInputChange,
    },
    {
      componentType: "input",
      type: "text",
      // label: "Office town/city",
      name: "address_line2",
      value: address_line2,
      placeholder: "Office address line2",
      handleChange: handleInputChange,
    },
    {
      componentType: "input",
      // label: "City",
      name: "city",
      value: city,
      placeholder: isEmployee ? "Office city/town*" : "Office city/town",
      errors: isEmployee && errors.city,
      helperText: isEmployee
        ? errors.city
          ? "Please enter office city/town"
          : ""
        : false,
      // selectOptions: [
      //   { id: 1, value: "Manchester", name: "Manchester" },
      //   { id: 2, value: "London", name: "London" },
      // ],
      // selectOptions: cityList,
      handleChange: handleInputChange,
    },
    {
      componentType: "input",
      // label: "Office county",
      placeholder: isEmployee
        ? "Office county/state/region*"
        : "Office county/state/region",
      // required:isEmployee,
      errors: isEmployee && errors.county,
      helperText: errors.county
        ? "Please enter Office county/state/region"
        : false,
      showHelperText: true,
      name: "county",
      value: county,
      handleChange: handleInputChange,
    },
    ...lastFields,
    {
      componentType: "rederComponent",
      value: magic20_fields,
      name: "magic20_fields",
      component: (
        <NewComponent handleChange={handleInputChange} value={magicFieldData} />
      ),
    },
  ].filter((item) =>
    userRole === "employee" ? !hideField.includes(item.label) : item
  );
  const [formInput, setFormInput] = useState(formArray);
  const [orgID, setOrgID] = useState();
  useEffect(() => {
    setLastFields((prev) => {
      const newArr = [...prev];
      if (errors.postcode || errors.country_list_id) {
        newArr[0].totalError = {
          inputError: errors.postcode,
          selectError: errors.country_list_id,
          inputErrorMsg: errors.postcode ? "Please enter Office post/zip" : "",
          selectErrorMsg: errors.country_list_id ? "Please Select Country" : "",
        };
      } else {
        newArr[0].totalError = {
          inputError: errors.postcode,
          selectError: errors.country_list_id,
          inputErrorMsg: errors.postcode ? "Please enter Office post/zip" : "",
          selectErrorMsg: errors.country_list_id ? "Please Select Country" : "",
        };
      }
      if (errors.phone) {
        newArr[1].errorMsg = "Please enter Office phone";
      } else {
        newArr[1].errorMsg = undefined;
      }
      return newArr;
    });
    console.log("entering into setting inside");
  }, [errors.postcode, errors.country_list_id, errors.phone]);
  useEffect(() => {
    setFormInput((prev) => {
      const newArr1 = [...prev];
      const newLastFields = [...lastFields];
      newLastFields[0].selectValue =
        prev[newArr1.findIndex((el) => el.selectName === "country_list_id")]
          .selectValue || country_list_id;
      newLastFields[0].inputValue =
        prev[newArr1.findIndex((el) => el.selectName === "country_list_id")]
          .inputValue || postcode;
      newLastFields[1].value =
        prev[newArr1.findIndex((el) => el.componentType === "phone")].value ||
        phone;
      newArr1[newArr1.findIndex((el) => el.selectName === "country_list_id")] =
        newLastFields[0];
      newArr1[newArr1.findIndex((el) => el.componentType === "phone")] =
        newLastFields[1];

      return newArr1;
    });
  }, [lastFields]);
  useEffect(() => {
    // setFormInput(formArray);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [
    errors,
    employee_statuses,
    countyList,
    cityList,
    department_lists,
    department_list_id,
    employee_status_id,
  ]);
  // useMemo(() => handleCountyList(country), [country]);
  // const countyName = county;
  // useMemo(() => handleCityList(country, countyName), [countyName]);

  useEffect(() => {
    setFormInput((prevState) => {
      let updatedState = [...prevState];
      const newlyAddedFields = [];

      const roles =
        selected_job_roles || job_role_lists?.map((item) => item.job_role);

      roles?.forEach((job_role, i) => {
        const name = `${job_role} access level`
          .split(" ")
          .join("_")
          ?.toLowerCase();
        const { access_level } = job_role_lists[i] || {};
        newlyAddedFields.push({
          isDynamic: true,
          componentType: "select",
          label: `${job_role} access level*`,
          helperText:
            errors &&
            errors.access_level &&
            !access_level &&
            "Please select an access level",
          for: job_role?.toLowerCase(),
          name: name,
          value: access_level && access_level,
          placeholder: "Access level",
          selectOptions: access_levels,
          handleChange: handleInputChange,
          fieldType: "dropdown",
        });
      });

      updatedState[1]["fields"] = [...newlyAddedFields].map(formDisabler);
      updatedState[2]["selectOptions"] = [...employee_statuses];
      // updatedState[27]["selectOptions"] = [...department_lists];
      // updatedState[28]["selectOptions"] = [...office_lists];
      // updatedState[29]["selectOptions"] = [...function_lists];
      updatedState[4]["itemArr"] = [...organisations];
      updatedState[1]["selectOptions"] = [...jobRoleListsSelector];
      // if (userRole !== "employee") {
      //   updatedState[31]["itemArr"] = [...franchiseSelector];
      // } else {
      //   updatedState[25]["itemArr"] = [...franchiseSelector];
      // }

      const updatedStateWithError = updatedState.map((item) => {
        return {
          ...item,
          ...(errors &&
            errors[item.name] && {
              helperText: errors[item.name]
                ? `Please ${
                    item.componentType === "input" ? "enter" : "select"
                  } ${(item.label || item.placeholder)?.replace("*", "")}`
                : null,
            }),
        };
      });

      return updatedStateWithError;
    });
  }, [
    selected_job_roles,
    errors,
    employee_statuses,
    countyList,
    cityList,
    job_role_lists,
    employee_status_id,
    department_lists,
    office_lists,
    function_lists,
    department_list_id,
    organisations,
    jobRoleListsSelector,
    franchiseSelector,
  ]);

  // const MultiChip = (props) => {
  //   for (const data in props.magicFieldData) {
  //     <MultiSelectChip
  //       label={data}
  //       name={`${data} _list_id}`}
  //       // value={department_list_id}
  //       placeholder={`Select ${data}`}
  //       selectOptions={magicFieldData[data]}
  //       apiVariable={`${data}s`}
  //       handleChange={handleChangeNew}
  //       // helperText=
  //       // {errors && errors.department_list_id && "Please select a Department"}
  //       dropDown={`${data}List`}
  //       field_name={`${data}`}
  //     />
  //   }
  // }

  // componentType: "SelectSpecific",
  // label: "Department",
  // name: "department_list_id",
  // value: department_list_id,
  // placeholder: "Select department",
  // selectOptions: department_lists,
  // // apiVariable: "departments",
  // handleChange: handleInputChange,
  // helperText:
  //   errors && errors.department_list_id && "Please select a Department",
  // dropDown: "DepartmentList",
  // field_name: "department",
  // console.log("magicFieldData", magicFieldData)
  // console.log("formInput", formInput)

  // for (const data in magicFieldData) {
  //   console.log("data", data)
  // }

  /////updates 19-07-2022
  const onChangeMultiItem = (obj, inputId, routeFrom) => {
    console.log("changes");
    // if (inputId == "org_attributes") {
    //   org_attribute.length = 0;
    //   setOrg_attribute(org_attribute.concat(obj));
    // }
    // if (inputId == "coach_attributes") {
    //   coach_attribute.length = 0;
    //   setCoach_attribute(coach_attribute.concat(obj));
    //   var currentOrg = orgListsArr.filter(
    //     (option) => option.organisation_name == userData.organisation
    //   );
    //   const values = obj.map((option) => option.value);
    //   const newData = { ...userData, assignmentMostUtilizeCoach: values };

    //   setUserData(newData);
    //   getAssignmentUtilizeCoach(
    //     currentOrg.length > 0 ? currentOrg[0].id : null,
    //     newData.assignmentMostUtilizeCoach
    //   );
    // }
  };
  //select logic

  // useEffect(() => {
  //   if (magicFieldData && Object.keys(magicFieldData).length) {
  //     const magic20 = [];
  //     Object.keys(magicFieldData).forEach(key => magic20.push({
  //       componentType: "SelectSpecific",
  //       label: key,
  //       name: key,
  //       id: key,
  //       value: [],
  //       placeholder: `Select ${key}`,
  //       // apiVariable: "countries",
  //       selectOptions: magicFieldData[key]?.length ? magicFieldData[key].map(item => ({ id: item, value: item })) : [],
  //       handleChange: handleInputChange,
  //       // helperText:
  //       //   errors && errors.country_list_id && "Please select the Office Country",
  //     }))
  //     setFormInput((oldValue) => [...oldValue, ...magic20])
  //   }
  //   //
  // }, [magicFieldData])

  return (
    <FormGenerator
      children={formInput.map(formDisabler)}
      submitURL={api_url.organisation}
      handleNext={props.handleNext}
      nextIndex={2}
      setId={props.setId}
    />
  );
}

const NewComponent = (props) => {
  let { id } = useParams();
  const globaluserData = useSelector((state) => state.commonReducer);
  const userRole = globaluserData?.role;
  const [magicFieldData, setMagicFieldData] = useState();
  const { handleChange } = props;
  const { magic20_fields } = useSelector(
    (state) => state.workInformationReducer.data
  );
  const { magic20_fields: magic20_fieldsError } = useSelector(
    (state) => state.workInformationReducer.errors
  );
  useEffect(() => {
    DataService.getDirectData(`/organisations/${id}`).then((response) => {
      response &&
        response.organisation_contact_info_id &&
        DataService.getDirectData(
          `/organisation_contact_infos/${response.organisation_contact_info_id}`
        ).then((res) => {
          setMagicFieldData(res.data.magic20_fields);
        });
    });
  }, [id]);
  const handleThisChange = (value, index, type, dynamicField) => {
    let oldValue = {},
      field = "";
    if (
      magic20_fields &&
      typeof magic20_fields === "object" &&
      Object.keys(magic20_fields).length > 0
    ) {
      oldValue = { ...magic20_fields };
      field = Object.keys(magic20_fields)[index];
    }
    if (
      Object.keys(oldValue).length === 0 &&
      magicFieldData &&
      field.length === 0
    ) {
      Object.keys(magicFieldData).forEach((el) => {
        oldValue[el] = [];
      });
      field = Object.keys(magicFieldData)[index];
    }
    oldValue[field] = value?.length ? value : [];
    handleChange(oldValue, 0, null, "magic20_fields");
  };

  let formField = [];
  magicFieldData &&
    Object.keys(magicFieldData)?.length &&
    Object.keys(magicFieldData).forEach((item) => {
      let error = false;
      if (
        typeof magic20_fieldsError === "boolean" &&
        magic20_fieldsError === true
      ) {
        error = true;
      }
      if (
        typeof magic20_fieldsError === "object" &&
        magic20_fieldsError[item]
      ) {
        error = true;
      }

      formField.push({
        componentType: "multiSelectChip",
        label: userRole === "employee" ? item + "*" : item,
        name: item,
        itemArr: magicFieldData[item]?.length
          ? magicFieldData[item].map((item) => ({ id: item, value: item }))
          : [],
        id: item,
        placeholder: `Select ${item}`,
        value:
          magic20_fields && magic20_fields[item] ? magic20_fields[item] : [],
        //   magicFieldData && magicFieldData[item] ? magicFieldData[item] : [],
        selectOptions: magicFieldData[item]?.length
          ? magicFieldData[item].map((item) => ({ id: item, value: item }))
          : [],
        field_name: "field_name",
        errors: error,
        helperText: error ? `Please select ${item}` : false,
        // growingAdionalParam: { magic20_field_id: options?.magic20_field_id },
        handleChange: handleThisChange,
      });
    });
  const [formInput1, setFormInput1] = useState(formField);

  useEffect(() => {
    setFormInput1(formField);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [magicFieldData]);

  // Form disabling
  const location = useLocation();

  let organisation_id = globaluserData?.organisation_id;
  let employee_id = globaluserData?.employee_id;

  const params = useParams();
  let unEditable = false;
  const isSameEmployee =
    userRole === "employee" &&
    Number(params.id) === Number(organisation_id) &&
    Number(employee_id) === Number(params.employeeid);
  if (location?.state?.unEditable && !isSameEmployee) {
    unEditable = true;
  }

  const formDisabler = (el) => {
    if (unEditable) {
      return { ...el, disabled: true };
    } else {
      return el;
    }
  };
  return (
    <Grid container>
      <Grid item xs={12}>
        <FormGenerator
          children={formField.map(formDisabler)}
          nextIndex={2}
          setId={props.setId}
          style={{
            width: "100%",
          }}
        />
      </Grid>
    </Grid>
  );
};
